import { useEffect, useState } from 'react';

const isOverflowing = (element) => element.scrollWidth > element.clientWidth;

export const useIsTruncated = (ref) => {
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const element = ref.current;

    if (!element) {
      return undefined;
    }

    const observer = new ResizeObserver(() => setIsTruncated(isOverflowing(element)));
    observer.observe(element);

    return () => observer.disconnect();
  }, [ref]);

  return isTruncated;
};
